export const about = {
  backToHome: "Terug naar home",
  title: "Over Novaventure",
  whoWeAre: {
    title: "Wie Wij Zijn",
    paragraph1: "Novaventure is een datagedreven adviesbureau gespecialiseerd in het transformeren van complexe data naar bruikbare bedrijfsstrategieën. Gevestigd in Blaasveld Willebroek, België, helpen we organisaties het volledige potentieel van hun data te ontsluiten om groei te stimuleren, operaties te optimaliseren en geïnformeerde beslissingen te nemen.",
    paragraph2: "Ons team van ervaren analisten en strategen combineert diepe branchekennis met geavanceerde analytische tools om inzichten te leveren die ertoe doen. We geloven dat data niet alleen cijfers zijn—het is de basis voor strategisch voordeel in het huidige competitieve landschap."
  },
  ourMission: {
    title: "Onze Missie",
    description: "Onze missie is om bedrijven te empoweren met de intelligentie die ze nodig hebben om te floreren. We transformeren ruwe data naar strategische inzichten, waardoor onze klanten zelfverzekerde beslissingen kunnen nemen, nieuwe kansen kunnen identificeren en voorop kunnen blijven lopen op markttendensen. We zijn toegewijd aan het leveren van excellentie, integriteit en meetbare resultaten in alles wat we doen."
  },
  whatWeDo: {
    title: "Wat We Doen",
    intro: "Bij Novaventure bieden we een uitgebreid pakket datagedreven diensten aan die zijn ontworpen om de unieke uitdagingen van moderne bedrijven aan te pakken:",
    services: {
      marketAnalysis: {
        title: "Marktanalyse:",
        description: "Diepgaand onderzoek naar markttrends, concurrentielandschappen en klantgedrag om strategische planning te informeren."
      },
      leadEnablement: {
        title: "Lead Enablement:",
        description: "Datagedreven strategieën om hoogwaardige prospects te identificeren, kwalificeren en converteren naar loyale klanten."
      },
      businessIntelligence: {
        title: "Business Intelligence:",
        description: "Aangepaste dashboards en rapportageoplossingen die real-time zichtbaarheid bieden in belangrijke prestatie-indicatoren."
      },
      strategicSupport: {
        title: "Strategische Ondersteuning:",
        description: "Doorlopende adviesdiensten om u te helpen navigeren door complexe bedrijfsuitdagingen en te profiteren van opkomende kansen."
      }
    }
  },
  ourApproach: {
    title: "Onze Aanpak",
    intro: "We geloven in een collaboratieve, klantgerichte aanpak. Elke samenwerking begint met het begrijpen van uw unieke bedrijfscontext, uitdagingen en doelen. Vanaf daar:",
    steps: {
      listen: {
        title: "Luisteren:",
        description: "We nemen de tijd om uw bedrijf, industrie en doelstellingen te begrijpen."
      },
      analyze: {
        title: "Analyseren:",
        description: "We duiken diep in uw data en ontdekken patronen, trends en kansen."
      },
      strategize: {
        title: "Strategiseren:",
        description: "We ontwikkelen op maat gemaakte aanbevelingen gebaseerd op solide bewijs en best practices uit de industrie."
      },
      execute: {
        title: "Uitvoeren:",
        description: "We werken samen met u om oplossingen te implementeren en resultaten te volgen."
      },
      optimize: {
        title: "Optimaliseren:",
        description: "We verfijnen strategieën continu om duurzaam succes te garanderen."
      }
    }
  },
  whyChoose: {
    title: "Waarom Kiezen Voor Novaventure",
    intro: "In een wereld die overloopt van data, is de echte uitdaging om informatie om te zetten in inzicht. Dat is waar we uitblinken. Dit onderscheidt ons:",
    reasons: {
      expertise: {
        title: "Expertise:",
        description: "Ons team brengt jarenlange ervaring mee over meerdere industrieën en analytische disciplines."
      },
      customization: {
        title: "Maatwerk:",
        description: "We geloven niet in one-size-fits-all oplossingen. Elke strategie is op maat gemaakt voor uw specifieke behoeften."
      },
      resultsDriven: {
        title: "Resultaatgericht:",
        description: "We focussen op uitkomsten die ertoe doen—omzetgroei, kostenbesparingen en concurrentievoordeel."
      },
      partnership: {
        title: "Partnerschap:",
        description: "We zien onszelf als een verlengstuk van uw team, toegewijd aan uw langetermijnsucces."
      }
    }
  },
  ourValues: {
    title: "Onze Waarden",
    values: {
      integrity: {
        title: "Integriteit",
        description: "We opereren met transparantie en eerlijkheid in al onze klantrelaties."
      },
      excellence: {
        title: "Excellentie",
        description: "We streven naar de hoogste normen in elk project dat we ondernemen."
      },
      innovation: {
        title: "Innovatie",
        description: "We verkennen continu nieuwe methodologieën en technologieën om betere resultaten te leveren."
      },
      collaboration: {
        title: "Samenwerking",
        description: "We geloven in samenwerken met onze klanten om gedeeld succes te bereiken."
      }
    }
  },
  getInTouch: {
    title: "Neem Contact Op",
    intro: "Klaar om uw data om te zetten in strategie? We horen graag van u. Of u nu een specifiek project in gedachten heeft of gewoon wilt verkennen hoe we kunnen helpen, ons team staat klaar om te assisteren.",
    contactInfo: "Contactinformatie",
    phone: "Telefoon",
    email: "Email",
    address: "Adres"
  }
};
